import { Paper } from '@mui/material';
import React from 'react';
export const TableSurface = ({ children }) => {
    return React.createElement(Paper, { sx: { border: (theme) => '1px solid ' + theme.palette.divider } }, children);
};
